import { get } from 'lodash'

const StateCellDisplayRenderer = (record, column, config) => {
  const stateId = record[column.key]
  const state = config.states.find((s) => s.value === stateId)
  return get(state, 'name')
}

export default StateCellDisplayRenderer
